<template>
    <div class="documentation-section">
        <div class="filter-section sub-filter">
            <h2>Documents Submitted</h2>
        </div>
        <div class="card document-section">
            <ul class="row">
                <li
                    v-for="(item, index) in documentInfoProp"
                    :key="index"
                    class="col-md-3"
                    :style="{ paddingBottom: '15px' }"
                >
                    <div v-if="item.fileName" class="document-detail" @click="openPopup(index)">
                        <div class="photo-section">
                            <div v-if="item.fileName && item.fileName.split('.').pop() === 'pdf'">
                                <pdf v-if="!!item.thumbNail" :src="pdfSrc + item.fileName">
                                </pdf>
                                <pdf v-if="!item.thumbNail" :src="pdfSrc + item.fileName">
                                </pdf>
                            </div>
                            <div v-else>
                                <img
                                    v-if="!!item.thumbNail"
                                    v-authenticated-image="item.thumbNail"
                                />
                                <img
                                    v-if="!item.thumbNail"
                                    v-authenticated-image="item.fileName"
                                />
                            </div>
                        </div>
                        <div class="upload-detail">
                            <div class="upload-thumbnail">
                                <div v-if="item.fileName && item.fileName.split('.').pop() === 'pdf'">
                                    <pdf v-if="!!item.thumbNail" :src="pdfSrc + item.fileName">
                                    </pdf>
                                    <pdf v-if="!item.thumbNail" :src="pdfSrc + item.fileName">
                                    </pdf>
                                </div>
                                <div v-else>
                                    <img
                                        v-if="!!item.thumbNail"
                                        v-authenticated-image="item.thumbNail"
                                    />
                                    <img
                                        v-if="!item.thumbNail"
                                        v-authenticated-image="item.fileName"
                                    />
                                </div>
                            </div>
                            <div class="upload-des">
                                <label>{{ index }}</label>
                                <p>
                                    Uploaded
                                    {{
                                        item.uploadedAt | moment('MMM D, YYYY')
                                    }}
                                </p>
                            </div>
                        </div>
                    </div>
                </li>
                <br />
            </ul>
        </div>
        <document-preview-popup
            :item="documentInfo.video"
        ></document-preview-popup>
        <!-- <picture-preview-popup
            :item="documentInfo.picture"
        ></picture-preview-popup> -->
        <id-card-preview-popup
            :item="documentInfo.identity"
        ></id-card-preview-popup>
        <cnic-back-preview-popup
            :item="documentInfo.cnicBack"
        ></cnic-back-preview-popup>
        <nominee-id-preview-popup
            :item="documentInfo.nomineeCNIC"
        ></nominee-id-preview-popup>
        <!-- <w9-form-preview-popup
            :item="documentInfo.w9Form"
        ></w9-form-preview-popup> -->
        <zakat-affidavit-preview-popup
            :item="documentInfo.zakatAffidavit"
        ></zakat-affidavit-preview-popup>
        <w8-form-preview-popup
            :item="documentInfo.w8Form"
        ></w8-form-preview-popup>
        <business-proof-preview-popup
            :item="documentInfo.businessProof"
        ></business-proof-preview-popup>
        <source-of-income-preview-popup
            :item="documentInfo.sourceOfIncome"
        ></source-of-income-preview-popup>
        <bill-preview-popup 
            :item="documentInfo.utility">
        </bill-preview-popup>
        <pmda-relative-popup 
            :item="documentInfo.pmdaRelativeForm">
        </pmda-relative-popup>
        <pmda-company-popup 
            :item="documentInfo.pmdaCompanyForm">
        </pmda-company-popup>
        <digital-signature
            :item="documentInfo.digitalSignature">
        </digital-signature>
    </div>
</template>

<script>
import documentPreviewPopup from '@/components/popups/DocumentPreviewPopup.vue'
// import picturePreviewPopup from '@/components/popups/PicturePreviewPopup.vue'
import idCardPreviewPopup from '@/components/popups/IDCardPreviewPopup.vue'
import cnicBackPreviewPopup from '@/components/popups/CnicBackPreviewPopup.vue'
import billPreviewPopup from '@/components/popups/BillPreviewPopup.vue'
import nomineeIdPreviewPopup from '@/components/popups/NomineeIDPreviewPopup.vue'
// import w9FormPreviewPopup from '@/components/popups/W9FormPreviewPopup.vue'
import zakatAffidavitPreviewPopup from '@/components/popups/ZakatAffidavitPreviewPopup.vue'
import w8FormPreviewPopup from '@/components/popups/W8FormPreviewPopup.vue'
import businessProofPreviewPopup from '@/components/popups/BusinessProofPreviewPopup.vue'
import sourceOfIncomePreviewPopup from '@/components/popups/SourceOfIncomePreviewPopup.vue'
import pmdaRelativePopup from '@/components/popups/PmdaRelativePopup.vue'
import pmdaCompanyPopup from '@/components/popups/PmdaCompanyPopup.vue'
import digitalSignature from '@/components/popups/DigitalSignaturePopup.vue'
import pdf from 'vue-pdf'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        documentPreviewPopup,
        // picturePreviewPopup,
        idCardPreviewPopup,
        cnicBackPreviewPopup,
        billPreviewPopup,
        nomineeIdPreviewPopup,
        // w9FormPreviewPopup,
        zakatAffidavitPreviewPopup,
        w8FormPreviewPopup,
        businessProofPreviewPopup,
        sourceOfIncomePreviewPopup,
        pmdaRelativePopup,
        pmdaCompanyPopup,
        digitalSignature,
        pdf,
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        documentInfo: {
            type: Object,
            default: null,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            pdfSrc:
                process.env.VUE_APP_FILE_SERVICE_URL ,
            // ext: this.documentInfo.w8Form.fileName.split('.').pop(),
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        documentInfoProp() {
          
            const obj = JSON.parse(JSON.stringify(this.documentInfo))
            
            const x = Object.keys(obj)
            
            x.forEach((key, index) => {
                if (obj[key].fileName === null) {
                    delete obj[key]
                }
            })
            return obj
            //    return this.documentInfo.filter(
            //        i => i.fileName !== null
            //     )
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        // console.log('document ', this.documentInfo)
        // console.log('pdf src ', this.pdfSrc)
        // console.log('ext ', this.ext)
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        openPopup(popup) {
            switch (popup) {
                // case 'picture':
                //     this.$bvModal.show('picture-preview-popup')
                //     break
                // case 'video':
                //     this.$bvModal.show('document-preview-popup')
                //     break
                case 'identity':
                    this.$bvModal.show('id-card-preview-popup')
                    break
                case 'cnicBack':
                    this.$bvModal.show('cnic-back-preview-popup')
                    break
                case 'utility':
                    this.$bvModal.show('bill-preview-popup')
                    break
                case 'sourceOfIncome':
                    this.$bvModal.show('source-of-income-preview-popup')
                    break
                case 'nomineeCNIC':
                    this.$bvModal.show('nominee-id-preview-popup')
                    break
                // case 'w9Form':
                //     this.$bvModal.show('w9-form-preview-popup')
                //     break
                case 'zakatAffidavit':
                    this.$bvModal.show('zakat-affidavit-preview-popup')
                    break
                case 'businessProof':
                    this.$bvModal.show('business-proof-preview-popup')
                    break
                case 'w8Form':
                    this.$bvModal.show('w8-form-preview-popup')
                    break
                case 'pmdaRelativeForm':
                    this.$bvModal.show('pmda-relative-popup')
                    break
                case 'pmdaCompanyForm':
                    this.$bvModal.show('pmda-company-popup')
                    break
                case 'digitalSignature':
                    this.$bvModal.show('digital-signature-popup')
                    break
            }
        },
    }, // End of Component > mounted
} // End of export default
</script>

